export default __webpack_public_path__ + "static/media/signature--white.949d87e1.png";